<template>
  <div class="modal" v-if="show">
    <div class="modal-content">
      <div v-if="failed" style="font-size: 16px; font-weight: 800; color: red;">
        Transaction failed!
      </div>
      <div v-else>
        <span class="close" @click="closeBuyModal">&times;</span>
        <h1>Are you Sure?</h1>
        <div class="recommended-units-card">
          <div class="left-unit-card">
            <h1>{{ card.actualTraded }} Units</h1>
            <div class="time_date">
              <div class="date-time">
                <img src="../../images/date.svg" alt="Date" class="icon">
                <p>{{card.startDate ?  new Intl.DateTimeFormat("en-US", {
                  day: "numeric",
                  month: "short",
                }).format(new Date(parseInt(card.startDate, 10))) :""}}</p>
              </div>
              <div class="date-time">
                <img src="../../images/clock.svg" alt="Clock" class="icon">
                <p>{{ card?.time }}</p>
              </div>
            </div>
            <p class="you_save">
  <img src="../../images/ruppee.svg" alt="Save Icon" class="save-icon" />
  {{ "You" }}
   <span class="amount">  save ₹{{this.savedMoney ? this.savedMoney : 10}} </span>
  {{ "on this purchase" }}
</p>
          </div>
          <div class="right-unit-card">
            <p class="price">{{ card.amount }}</p>
            <p>per unit ₹{{ (card.amount/card.actualTraded) ? (card.amount/card.actualTraded) : "e1" }}/-</p>
            <button v-if="!loading" @click="confirmAction" class="buy_loading">{{ showbuy ? 'Buy' : 'Sell' }}</button>
            <button v-else>loading...</button>
          </div>
        </div>
      </div>
    </div>
    <PaymentModal
      :show="showPaymentModal"
      :totAmount="totAmount"
      :discomCharges="discomCharges"
      :aggregatorFees="aggregatorFees"
      :crossWheelingCharges="crossWheelingCharges"
      :otherCharges="otherCharges"
      @close="closeAllModals"
      @payment-success="handlePaymentSuccess"
      @redirect-to-wallet="showWalletModal = true"

    />
    <WalletModal
      :isVisible="showWalletModal"
      @close="showWalletModal = false"
    />
  </div>
</template>

<script>
import TradeService from "@/services/trade.service";
import TransactionService from "@/services/transaction.service";
import { useToast } from 'vue-toastification';
import PaymentModal from "@/components/Payment.vue";
import WalletModal from "@/components/ViewWallet.vue"; 


export default {
  components: {
    PaymentModal,
    WalletModal 

  },
  props: {
    card: Object,
    selectedDay: String,
    show: Boolean,
    showbuy: Boolean,
  },
  data() {
    return {
      loading: false,
      failed: false,
      savedMoney: 10,
      showPaymentModal: false,
      showWalletModal: false, 
      unitRate: 0,
      discomCharges: 0,
      aggregatorFees: 0,
      crossWheelingCharges: 0,
      otherCharges: 0,
      totalAmount: 0,
      totAmount: 0,
    };
  },
  async mounted() {
    this.savedMoney = this.card ? (this.card?.actualTraded * ((this.card.amount / this.card.actualTraded) + 1.5) - this.card?.amount) : 10;
    this.unitRate = this.card?.amount / this.card?.actualTraded || 0;
    this.discomCharges = parseFloat((this.card.actualTraded * .21).toFixed(2));
    this.crossWheelingCharges = parseFloat((this.card.actualTraded * 1.01).toFixed(2));
    this.otherCharges = parseFloat((this.card.actualTraded * 0).toFixed(2));
    this.totalAmount =this.showbuy ? -(this.card?.amount + this.discomCharges  + this.crossWheelingCharges + this.otherCharges):(this.card?.amount - this.discomCharges  - this.crossWheelingCharges - this.otherCharges);
    this.totAmount =this.card?.amount ;
  },
  methods: {
    async buyOrSell(actionType) {
      this.loading = true;
      this.showPaymentModal = true;
    },

    async placeOrder(actionType) {
      if(!this.showPaymentModal){
        try {
        const transactionResponse = await TransactionService.createWalletTransaction(this.totalAmount, actionType,{
      unitRate: this.unitRate,
      discomCharges: this.discomCharges,
      crossWheelingCharges: this.crossWheelingCharges,
      otherCharges:this.otherCharges,
    });
    if(this.showbuy){
      const meta = await this.pollTransactionMeta(transactionResponse.id);
      if (!meta || !meta.order_id) {
        this.failed = true;
        this.loading = false;
        this.showToast("Transaction Failed", "Transaction Failed,Please try again.");
        return;
      }
      await TransactionService.updateWalletTransaction(transactionResponse.id);
    }
        const userWallet = await TransactionService.getWallet();
        const transactions=[...new Set([transactionResponse?.id, ...(userWallet[0].transactions || []).map((t) => t.id)])];
        console.log(transactions,"logging transactions");
        const updateResponse = await TransactionService.updateWallet(userWallet[0].id, transactions);
        const response = await TradeService.updateP2P(this.card, actionType);


        if (response && updateResponse) {
          this.showToast(``,
            `${actionType === "buy" ? "Bought" : "Sold"} Successfully.`);
        }
        this.$router.push({ path: '/transaction', query: { savedMoney: this.savedMoney } });
        this.loading = false;
      } catch (e) {
        this.failed = true;
        this.loading = false;
        this.showToast("Transaction Failed", "An error occurred during the transaction. Please try again.");
        throw new Error(e);
      }
      }
    },
    async pollTransactionMeta(transactionId, maxAttempts = 10, interval = 1000) {
  let attempts = 0;
  while (attempts < maxAttempts) {
    const trans = await TransactionService.getTransaction(transactionId);
    const meta = trans.meta ? JSON.parse(trans.meta) : null;
    if (meta && meta.order_id) {
      return meta;
    }
    await this.delay(interval);
    attempts++;
  }
  return null;
    },
  delay(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
},
    confirmAction() {
      const actionType = this.showbuy ? 'buy' : 'sell';
      this.buyOrSell(actionType);
    },
    showToast(title, message) {
      const toast = useToast();
      toast.success(message, {
        title: title,
        timeout: 1000,
        position: 'top-right',
      });
    },
    closeBuyModal() {
      this.$emit('close');
    },
    closeAllModals() {
      this.showPaymentModal = false;
      this.closeBuyModal();
    },
    handlePaymentSuccess() {
      this.showPaymentModal = false;
      this.placeOrder(this.showbuy ? 'buy' : 'sell');
    }
  }
};
</script>

<style scoped>
.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-content {
  background-color: white;
  padding: 20px 10px;
  border-radius: 5px;
  width: 375px;
}
.modal-content h1 {
  font-size: 20px;
  font-family: 'Montserrat', sans-serif;
  color: #453A94;
  font-weight: 600;
}
.close {
  position: absolute;
  top: 0;
  right: 10px;
  cursor: pointer;
}
.recommended-units-card {
  display: flex;
  justify-content: space-between;
  background: linear-gradient(to right, #100946, #453A94);
  padding: 15px 15px;
  border-radius: 15px;
}
.time_date {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-top: 12px;
}
.time_date p {
  margin: 0;
  font-size: 12px;
  font-family: 'Montserrat', sans-serif;
  color: #CAC9CC;
}
.left-unit-card h1 {
  font-size: 20px;
  font-family: 'Montserrat', sans-serif;
  color: #fff;
  text-align: left;
  font-weight: 700;
}
.you_save {
  color: #fff;
  font-size: 11px;
  font-family: "Montserrat", sans-serif;
  margin-top: 12px;
  text-align: left;
  display: flex;
  align-items: center;
}
.save-icon {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}
.amount {
  margin-left: 5px;
  margin-right: 5px;
  color: #F6B125;
  font-weight: bold;
}
.right-unit-card {
  background: linear-gradient(to bottom, #FFFFFF, #E6E6E6);
  border-radius: 15px;
  padding: 6px 10px;
}
.right-unit-card p:nth-child(1) {
  font-size: 16px;
  color: #13B78C;
  font-weight: 700;
  font-family: 'Montserrat', sans-serif;
  margin: 0;
}
.right-unit-card p:nth-child(2) {
  font-size: 12px;
  color: #656565;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
}
.right-unit-card button {
  font-size: 12px;
  font-family: 'Montserrat', sans-serif;
  font-weight: 600;
  background-color: #13B78C;
  border-radius: 40px;
  color: #ffffff;
  text-transform: uppercase;
  padding: 4px 15px;
  margin-top: 18px;
}
.right-unit-card .buy_loading {
  padding: 4px 30px;

}
.purchase_card_sell {
  display: flex;
  justify-content: space-between;
  gap: 30px;
  border-radius: 15px;
  padding: 24px;
  background: url("../../images/purchase_bg.png") no-repeat center center;
  background-size: cover;
  width: 100%;
}
.purchase_card {
  display: flex;
  gap: 30px;
  border-radius: 15px;
  padding: 24px;
  background: url("../../images/purchase_bg.png") no-repeat center center;
  background-size: cover;
  width: 100%;
}
.purchase_card div {
  display: flex;
  flex-direction: column;
  font-size: 12px;
  color: #ffffff;
}
.purchase, .save {
  margin: 0;
  font-size: 12px;
  color: #ffffff;
  font-family: 'Montserrat', sans-serif;
}
.date-time {
  display: flex;
  gap: 5px;
}
</style>
